import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {template} from './template';
import css from './index.styl?inline';

export const THEME = {
  GENERIC: `generic`,
  LIGHT: `light`,
  INFORMATION: `information`,
  SUCCESS: `success`,
  DELETED: `deleted`,
  FAILED: `failed`,
  POSITIVE: `positive`,
  NEGATIVE: `negative`,
  NEUTRAL: `neutral`,
};

export const LENGTH = {
  THIN: `thin`,
  WIDE: `wide`,
};

export const SIZE = {
  SMALL: `small`,
  MEDIUM: `medium`,
  LARGE: `large`,
};

interface TextHighlightAttrs {
  length?: string;
  size?: string;
  theme: string;
  text: string;
}

interface TextHighlightJsxProps {
  attrs?: TextHighlightAttrs;
}

export class TextHighlight extends Component<EmptyObj> {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      length: {type: `string`, default: LENGTH.THIN, enum: Object.values(LENGTH)},
      size: {type: `string`, default: SIZE.MEDIUM, enum: Object.values(SIZE)},
      theme: {type: `string`, default: THEME.NEUTRAL, enum: Object.values(THEME)},
      text: `string`,
    };
  }

  get config() {
    return {
      useShadowDom: true,
      template,
      css,
      helpers: {
        THEME,
        SIZE,
      },
    };
  }
}

export const TextHighlightEl = defineAndMakeJsxFactory<TextHighlightJsxProps>(`mp-text-highlight`, TextHighlight);
